import { Component, Host, Prop, State, getAssetPath, h } from '@stencil/core';
import { ImgHTMLAttributes } from 'react';

const getFallbackImage = () => getAssetPath('/assets/logos/fallback.svg');

@Component({
  tag: 'sportsline-image',
  styleUrl: 'sportsline-image.css',
  shadow: true,
})
export class SportslineImage {
  @State() error: boolean = false;

  /**
   * The image attributes
   */
  @Prop() props: Pick<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt'>;

  private get src() {
    return this.props?.src || getFallbackImage();
  }
  private errorHandler = (_: Event) => {
    this.error = true;
  };

  render() {
    const { src, ...rest } = this.props ?? {};

    return (
      <Host>
        <img src={this.error ? getFallbackImage() : this.src} onError={this.errorHandler} {...rest} />
      </Host>
    );
  }
}
